import Help from '@carbon/icons-react/es/Help';

import { useT } from '../i18n/index.js';
import { TOURS } from './tours.js';
import { useTourStore } from './tour-store.js';

/**
 * Bouton « revoir la visite » d'une section (ADR-0031, incrément 2) : rejoue à la demande la visite
 * guidée de la page. Ne s'affiche que si une visite existe pour cette portée — inutile sinon.
 */
export function TourReplayButton({ scope }: { scope: string }) {
  const t = useT();
  const requestTour = useTourStore((s) => s.requestTour);
  if (!TOURS[scope]) return null;
  return (
    <button
      type="button"
      className="ddp-tour-replay"
      onClick={() => requestTour(scope)}
      title={t('tour.replay')}
    >
      <Help size={16} />
      <span>{t('tour.replay')}</span>
    </button>
  );
}
